import getCharts from '../getCharts'
import { FacilityDetailsCRUD } from '../../constants/api.config'

export default async function Fn_FacilityDetailsCRUD(dataMode="", questions,name, mode,id="") {
  try {
    const payload = {dataMode,questions,name, mode, id}
    const res = await getCharts(FacilityDetailsCRUD, payload)
    return res.data
  } catch (error) {
    return error
  }
}
